import React from "react";

const BestReportsComponent = (props) => <div>{props.data}</div>;

export default BestReportsComponent;
